"use strict";
/**
 *
 * Fade
 *
 * https://github.com/mui-org/material-ui/blob/f55f3a4f808d1756d11d056195978affe4f65d5b/packages/material-ui/src/Fade/Fade.js
 *
 */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_transition_group_1 = require("react-transition-group");
const transition_1 = require("../styles/transition");
const theme_1 = require("../styles/theme");
const utils_1 = require("../utils");
const styles = {
    entering: {
        opacity: 1,
    },
    entered: {
        opacity: 1,
    },
};
const defaultTimeout = {
    enter: transition_1.defaultDuration.enteringScreen,
    exit: transition_1.defaultDuration.leavingScreen,
};
/**
 * The Fade transition is used by the [Modal](/components/modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */
exports.Fade = react_1.default.forwardRef(function Fade(props, ref) {
    const { children, in: inProp, onEnter, onExit, style, timeout = defaultTimeout } = props, other = __rest(props, ["children", "in", "onEnter", "onExit", "style", "timeout"]);
    const theme = theme_1.useTheme();
    const handleRef = utils_1.useForkRef(children.ref, ref);
    const handleEnter = (node, isAppearing) => {
        transition_1.reflow(node); // So the animation always start from the start.
        const transitionProps = transition_1.getTransitionProps({ style, timeout }, {
            mode: 'enter',
        });
        node.style.webkitTransition = theme.transition.create('opacity', transitionProps);
        node.style.transition = theme.transition.create('opacity', transitionProps);
        if (onEnter) {
            onEnter(node, isAppearing);
        }
    };
    const handleExit = (node) => {
        const transitionProps = transition_1.getTransitionProps({ style, timeout }, {
            mode: 'exit',
        });
        node.style.webkitTransition = theme.transition.create('opacity', transitionProps);
        node.style.transition = theme.transition.create('opacity', transitionProps);
        if (onExit) {
            onExit(node);
        }
    };
    return (react_1.default.createElement(react_transition_group_1.Transition, Object.assign({ appear: true, in: inProp, onEnter: handleEnter, onExit: handleExit, timeout: timeout }, other), (state, childProps) => {
        return react_1.default.cloneElement(children, Object.assign({ style: Object.assign(Object.assign(Object.assign({ opacity: 0, visibility: state === 'exited' && !inProp ? 'hidden' : undefined }, styles[state]), style), children.props.style), ref: handleRef }, childProps));
    }));
});
